import LabServiceCollection from "@/collections/LabServiceCollection";
import TestPackageGroupModel from "../../models/lab/TestPackageGroupModel";

/**
 * TestPackageGroup collection
 */
export default class TestPackageGroupCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return TestPackageGroupModel;
  }

  publicRoutes() {
    let model = (new (this.model())());
    return {
      fetch: process.env.VUE_APP_LAB_REPOSITORY_URL + '/api/v1/public/' + model.modelName(),
    }
  }

  /**
   * default collection configuration.
   */
  prepareFilter(CollectionFilter) {
    CollectionFilter.sortAddAsc('position');
    return CollectionFilter;
  }

}
